import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import HealthContainer from "../components/health/HealthContainer";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start"
  }
});

/**
 * HealthView lays out the view for system health
 */
const HealthView: React.FC = () => {
  const classes = useStyles();

  return (
    <Grid container className={classes.root}>
      <HealthContainer />
    </Grid>
  );
};

export default HealthView;
